import nfLoading from './nfLoading.vue'

export default nfLoading